// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { endOfSecond as fn } from "../endOfSecond.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const endOfSecond = convertToFP(fn, 1);

// Fallback for modularized imports:
export default endOfSecond;
